export const APP_STORE_URL = 'https://apps.apple.com/app/english-by-levels/id6758110339';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.domain.englishbylevels';
